module.exports = __webpack_public_path__ + "img/rocket_launch.56825baf.svg";